export default {
  InventoryItem: 'InventoryItem',
  AccountObject: 'AccountObject',
  AccountingObject: 'AccountingObject',
  BuPlanWithDraw: 'BuPlanWithDraw',
  SalaryScale: 'SalaryScale',
  Department: 'Department',
  EmployeeType: 'EmployeeType',
  PayrollItem: 'PayrollItem',
  BudgetSource: 'BudgetSource',
  BudgetChapter: 'BudgetChapter',
  BudgetProvide: 'BudgetProvide',
  BudgetKindItem: 'BudgetKindItem',
  BudgetItem: 'BudgetItem',
  BuPlanWithDrawDetail: 'BuPlanWithDrawDetail',
  BankInfo: 'BankInfo',
  Project: 'Project',
  Activity: 'Activity',
  Statistic: 'Statistic',
  BUTransfer: 'BUTransfer',
  BUTransferDetail: 'BUTransferDetail',
  BUTransferDetailParallel: 'BUTransferDetailParallel',
  PAEmployeeSalaryDetail: 'PAEmployeeSalaryDetail',
  Account: 'Account',
  AccountCategory: 'AccountCategory',
  BranchType: 'BranchType',
  Currency: 'Currency',
  BAWithdraw: 'BAWithdraw',
  BAWithdrawDetail: 'BAWithdrawDetail',
  BAWithdrawDetailParallel: 'BAWithdrawDetailParallel',
  InventoryCategory: 'InventoryCategory',
  Stock: 'Stock',
  BUPlanReceipt: 'BUPlanReceipt',
  BUPlanReceiptDetail: 'BUPlanReceiptDetail',
  TypeOfFund: 'TypeOfFund',
  BankInfoCategory: 'BankInfoCategory',
  BudgetGroupItem: 'BudgetGroupItem',
  CAReceipt: 'CAReceipt',
  CAReceiptDetail: 'CAReceiptDetail',
  CAReceiptDetailParallel: 'CAReceiptDetailParallel',
  BUPlanAdjustment: 'BUPlanAdjustment',
  BUPlanAdjustmentDetail: 'BUPlanAdjustmentDetail',
  BUVoucherList: 'BUVoucherList',
  BUVoucherListDetail: 'BUVoucherListDetail',
  BUVoucherListDetailParallel: 'BUVoucherListDetailParallel',
  BADeposit: 'BADeposit',
  BADepositDetail: 'BADepositDetail',
  BADepositDetailParallel: 'BADepositDetailParallel',
  BADepositDetailTax: 'BADepositDetailTax',
  CAPayment: 'CAPayment',
  CAPaymentDetail: 'CAPaymentDetail',
  CAPaymentDetailParallel: 'CAPaymentDetailParallel',
  InInwardOutward: 'InInwardOutward',
  InInwardOutwardDetail: 'InInwardOutwardDetail',
  InTransfer: 'InTransfer',
  InTransferDetail: 'InTransferDetail',
  InAdjustment: 'InAdjustment',
  InAdjustmentDetail: 'InAdjustmentDetail',
  SuTransfer: 'SuTransfer',
  SuTransferDetail: 'SuTransferDetail',
  SuIncrementDecrement: 'SuIncrementDecrement',
  SuIncrementDecrementDetail: 'SuIncrementDecrementDetail',
  FaIncrementDecrement: 'FaIncrementDecrement',
  FaIncrementDecrementDetail: 'FaIncrementDecrementDetail',
  FaDepreciation: 'FaDepreciation',
  FaDepreciationDetail: 'FaDepreciationDetail',
  FaAdjustment: 'FaAdjustment',
  FaAdjustmentDetail: 'FaAdjustmentDetail',
  FaAdjustmentDetailParallel: 'FaAdjustmentDetailParallel',
  PaWorkPoint: 'PaWorkPoint',
  PaWorkPointDetail: 'PaWorkPointDetail',
  PaOtherInputSalary: 'PaOtherInputSalary',
  BUPlanWDAdjustment: 'BUPlanWDAdjustment',
  BUPlanWDAdjustmentDetail: 'BUPlanWDAdjustmentDetail',
  BUTransferDetailPurchase: 'BUTransferDetailPurchase',
  PuInvoice: 'PuInvoice',
  PuInvoiceDetailPurchase: 'PuInvoiceDetailPurchase',
  AccountTransfer: 'AccountTransfer',
  SysRefType: 'SysRefType',
  AutoBusiness: 'AutoBusiness',
  BudgetFees: 'BudgetFees',
  Task: 'Task',
  PurchasePurpose: 'PurchasePurpose',
  BABankTransfer: 'BABankTransfer',
  BABankTransferDetail: 'BABankTransferDetail',
  BABankTransferDetailParallel: 'BABankTransferDetailParallel',
  CAPaymentDetailPurchase: 'CAPaymentDetailPurchase',
  SAInvoice: 'SAInvoice',
  SAInvoiceDetail: 'SAInvoiceDetail',
  BAWithdrawDetailPurchase: 'BAWithdrawDetailPurchase',
  BUBudgetReserve: 'BUBudgetReserve',
  BUBudgetReserveDetail: 'BUBudgetReserveDetail',
  GLVoucher: 'GLVoucher',
  GLVoucherDetail: 'GLVoucherDetail',
  GLVoucherDetailTax: 'GLVoucherDetailTax',
  GLVoucherDetailParallel: 'GLVoucherDetailParallel',
  SAReturn: 'SAReturn',
  SAReturnDetail: 'SAReturnDetail',
  AccountingObjectInfo: 'AccountingObjectInfo',
  AccountingObjectCategory: 'AccountingObjectCategory',
  InvoiceFormNumber: 'InvoiceFormNumber',
  VoucherType: 'VoucherType',
  BUCommitmentRequest: 'BUCommitmentRequest',
  BUCommitmentRequestDetail: 'BUCommitmentRequestDetail',
  BUCommitmentAdjustment: 'BUCommitmentAdjustment',
  BUCommitmentAdjustmentDetail: 'BUCommitmentAdjustmentDetail',
  BUOpeningCommitment: 'BUOpeningCommitment',
  BUOpeningCommitmentDetail: 'BUOpeningCommitmentDetail',
  ProjectBudgetDetail: 'ProjectBudgetDetail',
  Contract: 'Contract',
  Topic: 'Topic',
  TopicEstimate: 'TopicEstimate',
  GLVoucherList: 'GLVoucherList',
  GLVoucherListDetail: 'GLVoucherListDetail',
  ProjectExpense: 'ProjectExpense',
  FundStructure: 'FundStructure',
  QltsVoucher: 'QltsVoucher',
  QltsVoucherDetail: 'QltsVoucherDetail',
  QltsVoucherDetailParallel: 'QltsVoucherDetailParallel',
  BATransfer: 'BATransfer',
  BATransferDetail: 'BATransferDetail',
  BATransferDetailParallel: 'BATransferDetailParallel',
  OpeningSupplyEntry: 'OpeningSupplyEntry',
  CRERepList: 'CRERepList',
  FRTemplateCustom: 'FRTemplateCustom',
  CRERepExportList: 'CRERepExportList',
  AccountParallelRule: 'AccountParallelRule',
  AccountParallelRuleDetail: 'AccountParallelRuleDetail',
  DefaultAccount: 'DefaultAccount',
  AutoId: 'AutoId',
  OpeningAccountEntry: 'OpeningAccountEntry',
  StateBank: 'StateBank',
  BADepositDetailSale: 'BADepositDetailSale',
  OpeningAccountEntryStatistic: 'OpeningAccountEntryStatistic',
  PayrollItemColumn: 'PayrollItemColumn'
};
